export const environment:any = {
    production:true,
    // Prod  TCIL
    basePath : 'https://bepc-idcard.in',
    basePort:'/BEPCPMShri_API/',
    baseReportPath : 'https://bepc-idcard.in',
    baseReportPort:'/BEPCPMShri_SSRS/'


        // Prod  Railtel
        // basePath : 'https://lbdgujaratproject.in',
        // basePort:'/Gujaratlbd_API/',
        // baseReportPath : 'https://lbdgujaratproject.in',
        // baseReportPort:'/DispatchSSRS_API/'


        // ********

    // basePath : 'https://bepc-tlm.in',
    // basePort:'/NsdcdemoAPI/',
    // baseReportPath : 'https://bepc-tlm.in',
    // baseReportPort:'/Nsdcdemo_ssrs_api/'
};
